import { ca } from '@cian/analytics';

export function trackOffersReliableLabelClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'flats_reliable_dev',
    useLastProducts: true,
  });
}
